export const timelineItemColors = [
  "#A79B8E",
  "#616161",
  "#795548",
  "#8E24AA",
  "#4285F4",
  "#039BE5",
  "#009688",
  "#0B8043",
  "#9E69AF",
  "#B39DDB",
  "#7986CB",
  "#3F51B5",
  "#33B679",
  "#7CB342",
  "#C0CA33",
  "#E4C441",
  "#F6BF26",
  "#F09300",
  "#EF6C00",
  "#F4511E",
  "#E67C73",
  "#D50000",
  "#D81B60",
  "#AD1457",
]

export const terminalBackground = "#084f75"
